module.exports = __webpack_public_path__ + "background-triangle-full.77e5c91b6073221ccc09672f19540af8.png";